const ROADMAP_ITEMS = [
    {
        done: true,
        title: 'Antal personer online',
    },
    {
        done: true,
        title: 'Autofokus på sökfältet',
    },
    {
        done: true,
        title: 'Visa personer i mötesrum',
    },
    {
        done: true,
        title: 'Favoritmarkera kollegor',
    },
    {
        done: true,
        title: 'Smartare namn: stavningsvarianter och efternamnsinitial',
    },
    {
        done: false,
        title: 'Mer information om mötesrummen',
    },
    {
        done: false,
        title: 'Slackintegration',
    },
    {
        done: false,
        title: 'Visa återkommande vs enstaka möten',
    },
    {
        done: false,
        title: 'Status på vattenkokare',
    },
    {
        done: false,
        title: 'Se flera dagar framåt',
    },
    {
        done: false,
        title: 'Bring back marodörkartan',
    },
];

const SORTED_ROADMAP_ITEMS = [ ...ROADMAP_ITEMS ].sort( ( a, b ) => {
    return ( b.done ? 1 : 0 ) - ( a.done ? 1 : 0 );
} );

function Roadmap() {
    return (
        <div className="roadmap">
            <div className="roadmap-header">
                <h2>Roadmap</h2>
            </div>
            <ul className="roadmap-list">
                { SORTED_ROADMAP_ITEMS.map((item) => (
                    <li
                        key = { item.title }
                        className = { `roadmap-item${ item.done ? ' roadmap-item-done' : '' }` }
                    >
                        <span
                            className = { 'roadmap-checkbox' }
                            aria-hidden = { 'true' }
                        >
                            { item.done ? '✓' : '' }
                        </span>
                        <span className="roadmap-item-title">{ item.title }</span>
                    </li>
                )) }
            </ul>
        </div>
    );
}

export default Roadmap;
